<template>
  <v-card elevation="0" width="100%">
    <v-dialog v-model="dialog" max-width="500">
      <Confirm
          title="Salvar"
          message="Tem certeza de que deseja salvar estes dados?"
          buttonText="Salvar"
          @cancel="dialog = false"
          @action="submit"
      />
    </v-dialog>

    <v-form ref="standardShippingResellers">
      <v-row cols="12" sm="12" md="12" lg="12" class="ma-0">
        <v-col cols="12" sm="12" md="12" lg="12">
          <label class="ml-1 mb-2 label-details">Frete padrão das revendas</label>
          <vuetify-money
              color="black"
              v-bind:outlined="outlined"
              background-color="#F5F5F5"
              placeholder="0.00"
              :rules="[rules.required]"
              required
              hide-details
              style="border: 1px solid #979797; border-radius: 7.5px; width: 100%;!important;"
              v-model="defaultFrete"
              v-bind:options="options"
          ></vuetify-money>
        </v-col>
      </v-row>

      <v-row class="pb-3" justify="center">
        <v-col cols="12" md="6">
          <v-btn
              class="primary-button"
              color="normalred"
              elevation="0"
              @click="validate()"
              block
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";
import Confirm from "../../components/ConfirmExit.vue";
import {VMoney} from "v-money";

export default {
  name: "StandardShippingResellers",
  components: {
    Confirm,
  },
  props: {},
  data: () => ({
    outlined: true,
    options: {
      locale: "pt-BR",
      prefix: "R$",
      suffix: "",
      length: 11,
      precision: 2
    },
    apiService: new ApiService(),
    dialog: false,
    defaultFrete: null,
    rules: {
      nameRules: (v) => (v && v.length <= 128) || "Nome deve ter no máximo 128 caracteres",
      required: (value) => !!value || "Campo requerido.",
      min: (v) => v.length >= 4 || "Minimo de 4 caracteres.",
      postalCodeRules: (v) => (v && v.length <= 10) || "CEP deve ter no máximo 10 caracteres",
    },
  }),
  async created() {
    await this.getStandardShippingValue();
  },
  methods: {
    async getStandardShippingValue() {
      await this.apiService.get("resale/getOneDefaultFrete").then((response) => {
        if (response.body !== "") {
          this.defaultFrete = response.defaultFrete;
        }
      });
    },
    validate() {
      if (!this.$refs.standardShippingResellers.validate()) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Digite o valor do frete padrão das revendas",
          trace: null,
        });
        return
      }
      this.dialog = true;
    },
    async submit() {
      try {
        let url = "resale/addStandardShippingCost";
        const resale = {
          DefaultFrete: parseFloat(this.defaultFrete).toFixed(2)
        }
        await this.apiService.put(url, resale)
            .then((resp) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: resp.message,
                message: resp.message,
                trace: null,
              });

              this.dialog = false;
              this.loading = false;
            })
            .catch((err) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "Erro ao cadastrar produto",
                message: err.body.message,
                trace: null,
              });

              this.dialog = false;
              this.loading = false;
            });
      } catch (e) {

      }
    },
  },
};
</script>
<style scoped>
</style>
